module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgPHBhdGggZmlsbD0iIzAwMCIgZD0iTTAsMTguNzk3Njg3OSBMMCwyNCBMNS4yNTcwMDkzNSwyNCBMMjAuNzYxNjgyMiw4LjY1NjY0NzQgTDE1LjUwNDY3MjksMy40NTQzMzUyNiBMMCwxOC43OTc2ODc5IFogTTIyLjAyMzM2NDUsMy4yNDYyNDI3NyBMMTguNzQyOTkwNywwIEwxNi4xNzc1NzAxLDIuNTM4NzI4MzIgTDIxLjQzNDU3OTQsNy43NDEwNDA0NiBMMjQsNS4yMDIzMTIxNCBMMjIuMDIzMzY0NSwzLjI0NjI0Mjc3IFoiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./images/edit_black.svg
// module id = 233
// module chunks = 0